export default "__VITE_ASSET__e113130e__"